import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Star, User } from "lucide-react";

import { TabSwitcher } from "components/ui/TabSwitcher";

import { DoctorDetailsTab } from "./components/DoctorDetailsTab/DoctorDetailsTab";
import { DrugFavouritesTab } from "./components/DrugFavouritesTab/DrugFavouritesTab";
import styles from "./ProfilePage.module.css";

const TAB_OPTIONS = [
  {
    value: "doctor-details",
    label: "Profile Details",
    icon: <User size={16} />,
  },
  {
    value: "drug-favourites",
    label: "Drug Favourites",
    icon: <Star size={16} />,
  },
];

const Profile = () => {
  const [searchParams] = useSearchParams();

  const [activeTab, setActiveTab] = useState(() => {
    const tabParam = searchParams.get("tab");
    return tabParam === "drug-favourites" ? tabParam : "doctor-details";
  });

  return (
    <div className={styles.page}>
      <TabSwitcher
        options={TAB_OPTIONS}
        value={activeTab}
        onChange={setActiveTab}
        fullWidth
        marginTop={16}
        marginBottom={24}
      />

      {activeTab === "doctor-details" && <DoctorDetailsTab />}
      {activeTab === "drug-favourites" && <DrugFavouritesTab />}
    </div>
  );
};

export { Profile };
